import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { map, tap } from 'rxjs/operators';

const signupURL = "assets/signup.php"
const loginURL = "assets/login.php"
const logoutURL = "assets/logout.php"

const initURL = "assets/init.php"

const isLoggedInURL = "assets/is_logged_in.php"

const welcomeInitURL = "assets/welcome_init.php"

const addGearURL = "assets/add_gear.php"
const editGearURL = "assets/edit_gear.php"

const getMyGearURL = "assets/get_my_gear.php"
const getGearURL = "assets/get_gear.php"

const deleteGearURL = "assets/delete_gear.php"

const getGearPoolURL = "assets/get_pool.php"

const requestReservationURL = "assets/request_reservation.php"

const handleRequestURL = "assets/handle_request.php"

const getReservationURL = "assets/get_reservation.php"

const getCategoriesURL = "assets/get_categories.php"


const adminInitURL = "assets/admin/init.php"
const adminAddCategoryURL = "assets/admin/add_category.php"
const adminEditCategoryURL = "assets/admin/edit_category.php"
const adminRemoveCategoryURL = "assets/admin/remove_category.php"
const adminEditConfURL = "assets/admin/edit_conf.php"
const adminEditUserURL = "assets/admin/edit_user.php"
const adminRemoveUserURL = "assets/admin/remove_user.php"
const adminSetVerifiedURL = "assets/admin/set_verified.php"
const adminGetZipURL = "assets/admin/do_zip.php"
const adminDeleteOldReservationsURL = "assets/admin/delete_old_reservations.php"


const getConfURL = "assets/get_conf.php"


const resetSendEmailURL = "assets/reset/send_email.php"
const resetPasswordURL = "assets/reset/reset_pass.php"

@Injectable({
  providedIn: 'root'
})
export class AppService {

  private isLoggedInSubject: BehaviorSubject<boolean>
  public isLoggedIn$: Observable<boolean>
  public _isLoggedIn = false

  public willGoBack: boolean = false
  public savedRoute: string

  public userId: number = 0

  public isAdmin: boolean = false


  constructor(private http: HttpClient) { 
    this.isLoggedInSubject = new BehaviorSubject<boolean>(false)
    this.isLoggedIn$ = this.isLoggedInSubject.asObservable()

    //this.checkLoggedIn().subscribe()
  }

  checkLoggedIn() {
    return this.http.get(isLoggedInURL).pipe(map(ret => {
      this.userId = ret['userId']
      if (ret['result']) {
        this.isAdmin = ret['isAdmin']
      } 
      this.isLoggedInSubject.next(ret['result'])
      this._isLoggedIn = ret['result']

      return ret
      //this.isLoggedIn = ret['result']
    }))
  }

  signup(username: string, password: string, name: string, email: string) {
    return this.http.post(signupURL, {username: username, password: password, name:name, email: email})
  }

  login (username: string, password: string) {
    return this.http.post(loginURL, {username: username, password: password}).pipe(map(ret => {
      if (ret['result']) {
        this.isAdmin = ret['isAdmin']
        this.userId = ret['userId']


        this.isLoggedInSubject.next(ret['result'])
        this._isLoggedIn = ret['result']
      }

      return ret
    }))
  }

  logout () {
    this.isLoggedInSubject.next(false)
    return this.http.get(logoutURL)
  }


  rootInit() {
    return this.http.get(initURL)
  }


  welcomeInit() {
    return this.http.get(welcomeInitURL)
  }

/*


  postFile(fileToUpload: File): Observable<boolean> {
    const endpoint = 'assets/upload.php';
    const formData: FormData = new FormData();
    formData.append('image', fileToUpload, fileToUpload.name);
    return this.http
      .post(endpoint, formData, { headers: {} })
      .pipe(map(() => { return true; }))
}
*/
  addGear(img: File, category_id: string, betegnelse: string, placering: string, postnr: string, minimumsFrist: string, saerligt: string, ejernavn: string, kpNavn: string, kpEmail: string, kpTlf: string) {
    const formData: FormData = new FormData()

    if (img) {
      formData.append('img', img, img.name)
    }
    formData.append('category_id', category_id)
    formData.append('betegnelse', betegnelse)
    formData.append('placering', placering)
    formData.append('postnr', postnr)
    formData.append('minimumsFrist', minimumsFrist)
    formData.append('saerligt', saerligt)
    formData.append('ejernavn', ejernavn)
    formData.append('kpNavn', kpNavn)
    formData.append('kpEmail', kpEmail)
    formData.append('kpTlf', kpTlf)

    return this.http.post(addGearURL, formData)
  }
  editGear(id: number, img: File, category_id: string, betegnelse: string, placering: string, postnr: string, minimumsFrist: string, saerligt: string, ejernavn: string, kpNavn: string, kpEmail: string, kpTlf: string) {
    const formData: FormData = new FormData()

    if (img) {
      formData.append('img', img, img.name)
    }
    formData.append('id', id.toString())
    formData.append('category_id', category_id)
    formData.append('betegnelse', betegnelse)
    formData.append('placering', placering)
    formData.append('postnr', postnr)
    formData.append('minimumsFrist', minimumsFrist)
    formData.append('saerligt', saerligt)
    formData.append('ejernavn', ejernavn)
    formData.append('kpNavn', kpNavn)
    formData.append('kpEmail', kpEmail)
    formData.append('kpTlf', kpTlf)

    return this.http.post(editGearURL, formData)
  }

  getMyGear() {
    return this.http.get(getMyGearURL)
  }

  getGear(id: number) {
    let params = new HttpParams().set("id",id.toString());
    return this.http.get(getGearURL, {params: params})
  }

  getCategories() {
    return this.http.get(getCategoriesURL)
  }

  deleteGear(id: number) {

    let params = new HttpParams().set("id",id.toString());
    return this.http.get(deleteGearURL, {params: params})
  }



  getGearPool() {
    //let params = new HttpParams().set("id",id.toString());
    return this.http.get(getGearPoolURL)
  }

  requestReservation(gearId: number, startYear: number, startMonth: number, startDay: number,
                    endYear: number, endMonth: number, endDay: number, comment: string) {
    return this.http.post(requestReservationURL, {gearId: gearId, startYear: startYear, startMonth: startMonth,
                                                startDay: startDay, endYear: endYear, endMonth: endMonth,
                                                endDay: endDay, comment: comment})
  } 

  acceptRequest(id: number) {
    return this.http.post(handleRequestURL, {action: "accept", id: id})
  }
  denyRequest(id: number) {
    return this.http.post(handleRequestURL, {action: "deny", id: id})
  }

  unsetReservation(id: number)  {
    return this.http.post(handleRequestURL,  {action: "unset", id: id})
  }


  getReservation(gearId: number, year: number, month: number, day: number) {
return this.http.post(getReservationURL, {gearId: gearId, year: year, month: month,
                                day: day})
} 

  getConf( ) {
    return this.http.get(getConfURL)
  }


  adminInit() {
    return this.http.get(adminInitURL)
  }

  adminAddCategory(name: string) {
    return this.http.post(adminAddCategoryURL, {name: name})
  }

  adminRemoveCategory(id: number) {
    return this.http.post(adminRemoveCategoryURL, {id: id})
  }

  adminEditCategory(id: number, name: string) {
    return this.http.post(adminEditCategoryURL, {id: id, name: name})
  }


  adminEditConf(params: object) {
    return this.http.post(adminEditConfURL, {params: params})
  }

  adminEditUser(id: number, username: string, password: string, name: string, email: string) {
    return this.http.post(adminEditUserURL, {id: id, username: username, password: password, name: name, email: email})
  }

  adminRemoveUser(id: number) {
    return this.http.post(adminRemoveUserURL,  {id: id})
  }

  adminSetVerified(id: number, verified: boolean) {
    return this.http.post(adminSetVerifiedURL, {id: id, verified: verified})
  }

  adminGetZipFile() {
    return this.http.get(adminGetZipURL)
  }

  adminDeleteOldReservations() {
    return this.http.get(adminDeleteOldReservationsURL)
  }

  resetSendEmail(username: string) {
    return this.http.post(resetSendEmailURL, {username: username})
  }
  resetPassword(password: string, token: string) {
    return this.http.post(resetPasswordURL, {password: password, token: token})
  }
}
